import AssignmentGeneralForm from "@app/components/forms/assignments/assignment-general-form.tsx";
import Kvp from "@app/components/kvp.tsx";
import { PageContainer } from "@app/components/page-container.tsx";
import useClientData from "@app/data-hooks/use-client-data.ts";
import { Box } from "@mui/material";
import { createFileRoute } from "@tanstack/react-router";
import { QueryStatusRouter } from "bi-lib";

export const Route = createFileRoute("/_authenticated/_manager/assignment/create/$clientId")({
    component: Component,
});

function Component() {
    const clientId = +Route.useParams().clientId;

    const { client } = useClientData({ clientId });

    return (
        <PageContainer title={"Create Assignment"} from={"/assignment/"}>
            <QueryStatusRouter queryHook={client}>
                <Box py={1}>
                    <Kvp keyTitle={"Client"} keyWidth={3}>
                        {client.data?.clientName}
                    </Kvp>
                </Box>
            </QueryStatusRouter>
            <AssignmentGeneralForm clientId={clientId} />
        </PageContainer>
    );
}
